<template>
  <div class="app-container">
    <!-- 搜索区 -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" label-width="80px" size="mini" style="width: 100%;">
        <div class="formItemBox">
          <el-form-item label="公司:">
            <el-select v-model="searchForm.companyName" placeholder="请选择" clearable filterable style="width:180px">
              <el-option v-for="item in companyList" :key="item.companyCode || item.itemNo || item.id" :label="item.companyName || item.showName" :value="item.companyName || item.showName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行名称:">
            <el-select v-model="searchForm.bankName" placeholder="请选择" clearable filterable style="width:180px">
              <el-option v-for="item in bankNameList" :key="item.id" :label="item.showName" :value="item.showName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="担保人:">
            <el-select v-model="searchForm.securityUser" placeholder="请选择" clearable filterable style="width:150px">
              <el-option v-for="item in securityUserList" :key="item.id" :label="item.showName" :value="item.showName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法人:">
            <el-select v-model="searchForm.legalPerson" placeholder="请选择" clearable filterable style="width:150px">
              <el-option v-for="item in legalPersonList" :key="item.id" :label="item.showName" :value="item.showName"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex;align-items: center;">
          <div class="searchBtnBox" style="margin: 0;">
            <el-form-item>
              <el-button type="primary" class="allBtn" v-if="btnFlg[0]" @click="searchFn">查询</el-button>
              <el-button type="primary" class="allBtn" @click="resetForm">重置</el-button>
              <el-button type="primary" class="allBtn" v-if="btnFlg[1]" @click="addFn">新增</el-button>
              <el-button type="primary" class="allBtn" v-if="btnFlg[2]" @click="exportFn">导出</el-button>
            </el-form-item>
          </div>
          <!-- 合计行 -->
          <div class="sumBox">
            授信金额合计：<span>{{ sumData.totalAmount || '0.00' }}</span> 万元， 已贷金额合计：<span>{{ sumData.totalLoaned || '0.00' }}</span> 万元， 未用授信金额合计：<span>{{ sumData.totalUnused || '0.00' }}</span> 万元
          </div>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" height="100%" style="width: 100%" class="tableComent" highlight-current-row center border :cell-style="cellStyle">
        <el-table-column type="index" width="55" label="序号" fixed="left"></el-table-column>
        <el-table-column width="220" label="操作" fixed="left">
          <template slot-scope="scope">
            <div>
              <el-button type="text" v-if="scope.row.loanAmount<=0 && btnFlg[3]" size="mini" @click="editFn(scope.row)">修改</el-button>
              <el-button type="text" v-if="scope.row.loanAmount<=0 && btnFlg[4]" size="mini" @click="delFn(scope.row)">删除</el-button>
              <el-button type="text" v-if="btnFlg[5]" size="mini" @click="detailFn(scope.row)">详情</el-button>
              <el-button type="text" v-if="btnFlg[6]" size="mini" @click="creditFileFn(scope.row)">授信资料</el-button>
              <el-button type="text" v-if="btnFlg[7]" size="mini" @click="loanDetailFn(scope.row)">贷款明细</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" width="260" label="公司" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bankName" width="260" label="银行名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creditAmount" width="120" label="授信金额(万元)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loanAmount" width="120" label="已贷金额(万元)" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unUseCreditAmount" width="120" label="未用金额(万元)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creditExpireDate" width="100" label="授信到期日" :formatter="dateFormat" show-overflow-tooltip></el-table-column>
        <el-table-column prop="securityTypeName" width="100" label="担保方式" show-overflow-tooltip></el-table-column>
        <el-table-column prop="securityUser" width="100" label="担保人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isCredit" width="90" label="是否上征信" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creditLife" width="80" label="授信年限" show-overflow-tooltip></el-table-column>
        <el-table-column prop="hockLife" width="80" label="抵押年限" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creditMode" width="180" label="授信方式" show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalPerson" width="100" label="法人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" width="160" label="创建时间" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="createUserName" width="100" label="创建人" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div style="text-align: left;">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <!-- 新增/修改/详情弹框 -->
    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="close" center width="800px">
      <el-form :rules="rules" :model="addForm" :validate-on-rule-change="false" ref="addForm" label-width="100px" size="small" :inline="false" v-if="dialogVisible">
        <!-- 详情接口返回的后端统计字段：贷款金额 / 未用授信金额 -->
        <el-row v-if="isDetail && (detailLoanAmountDisplay !== '' || detailUnUseCreditAmountDisplay !== '')" :gutter="20" style="margin-bottom:4px;background:#f5f7fa;border-radius:4px;padding:6px 0;">
          <el-col :span="12" style="text-align:center;"><span style="color:#909399;">贷款金额：</span><b style="color:#F56C6C;">{{ detailLoanAmountDisplay }}</b><span style="color:#909399;"> 万元</span></el-col>
          <el-col :span="12" style="text-align:center;"><span style="color:#909399;">未用授信金额：</span><b style="color:#67C23A;">{{ detailUnUseCreditAmountDisplay }}</b><span style="color:#909399;"> 万元</span></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司名称:" prop="companyName">
              <el-select v-model="addForm.companyName" placeholder="请选择" clearable filterable :disabled="isDetail" style="width:100%" @change="companyNameChange">
                <el-option v-for="item in companyList" :key="item.companyCode || item.itemNo || item.id" :label="item.companyName || item.showName" :value="item.companyName || item.showName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行名称:" prop="bankName">
              <el-select v-model="addForm.bankName" placeholder="请选择" clearable filterable :disabled="isDetail" style="width:100%" @change="bankNameChange">
                <el-option v-for="item in bankNameList" :key="item.id" :label="item.showName" :value="item.showName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="授信金额:" prop="creditAmount">
              <el-input-number v-model="addForm.creditAmount" placeholder="请输入" :min="0" :precision="2" :step="100" controls-position="right" :disabled="isDetail" style="width:100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授信到期日:" prop="creditExpireDate">
              <el-date-picker v-model="addForm.creditExpireDate" type="date" format="yyyy-MM-dd"    value-format="timestamp" placeholder="请选择" :disabled="isDetail" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="担保方式:" prop="securityTypeCode">
              <el-select v-model="addForm.securityTypeCode" placeholder="请选择" clearable filterable :disabled="isDetail" style="width:100%" @change="securityTypeChange">
                <el-option v-for="item in securityTypeList" :key="item.id" :label="item.showName" :value="item.itemNo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="担保人:" prop="securityUserARR">
              <el-select v-model="addForm.securityUserARR" placeholder="请选择" clearable filterable multiple :disabled="isDetail" style="width:100%">
                <el-option v-for="item in securityUserList" :key="item.id" :label="item.showName" :value="item.showName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="是否上征信:" prop="isCredit">
              <el-select v-model="addForm.isCredit" placeholder="请选择" clearable :disabled="isDetail" style="width:100%">
                <el-option label="上" :value="1"></el-option>
                <el-option label="不上" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="法人:" prop="legalPerson">
              <el-select v-model="addForm.legalPerson" placeholder="请选择" clearable filterable :disabled="isDetail" style="width:100%">
                <el-option v-for="item in legalPersonList" :key="item.id" :label="item.showName" :value="item.showName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="授信年限:" prop="creditLife">
              <el-select v-model="addForm.creditLife" placeholder="请选择/输入" clearable filterable allow-create default-first-option :disabled="isDetail" style="width:100%">
                <el-option v-for="item in termYearsList" :key="item.id" :label="item.showName" :value="Number(item.showName)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授信方式:" prop="creditMode">
              <el-select v-model="addForm.creditMode" placeholder="请选择" clearable :disabled="isDetail" style="width:100%">
                <el-option label="一次性支用，受托支付" value="一次性支用，受托支付"></el-option>
                <el-option label="循环支用" value="循环支用"></el-option>
                <el-option label="一次性支用" value="一次性支用"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="抵押年限:" prop="hockLife">
              <el-select v-model="addForm.hockLife" placeholder="请选择/输入" clearable filterable allow-create default-first-option :disabled="isDetail" style="width:100%">
                <el-option v-for="item in termYearsList" :key="item.id" :label="item.showName" :value="Number(item.showName)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="授信资料:">
              <uploadFiles v-if="!isDetail" :fileArr.sync="imgList" :max="10" @remove="remove"></uploadFiles>
              <div v-else>
                <div v-for="f in imgList" :key="f.uid || f.id || f.name" style="line-height:22px;">
                  <a :href="f.url" target="_blank" style="color:#409EFF;">{{ f.name }}</a>
                </div>
                <span v-if="imgList.length === 0" style="color:#909399;">暂无授信资料</span>
              </div>
              <span v-if="!isDetail" class="el-upload__tip" style="margin-left:10px;color:#909399;">支持多个文件上传，非必传</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="说明:">
              <el-input type="textarea" v-model.trim="addForm.remark" :placeholder="isDetail ? '' : '请输入'" maxlength="500" :disabled="isDetail" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" size="mini">关 闭</el-button>
        <el-button type="primary" size="mini" @click="saveFn" v-if="!isDetail">保 存</el-button>

      </span>
    </el-dialog>

    <!-- 授信资料（查看凭证）弹框 -->
    <el-dialog title="授信资料" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="creditFileFlag" width="320px" center>
      <div class="fujianBox">
        <el-button type="text" v-for="item in creditFileList" :key="item.name" @click="creditFileClick(item)">{{ item.name }}</el-button>
      </div>
    </el-dialog>
    <!-- 查看图片弹框 -->
    <el-dialog title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="lookImgFlag" append-to-body width="800px" center>
      <div style="text-align:center;">
        <el-image style="width:100%;" :src="imgUrl" fit="contain"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDictionaryDetailList,
  findCreditInfoList,
  addCreditInfo,
  deleteCreditInfo,
  updateCreditInfo,
  getCreditInfo,
  getUserCompanyDropDown
} from '@/api/common-signature'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { dateTimeFormat, dateFormat } from '@/utils/util'
import { getBtn } from '@/utils/getButton'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
export default {
  components: {
    uploadFiles
  },
  data () {
    return {
      dateTimeFormat,
      dateFormat,
      searchForm: {
        pageNo: 1,
        pageSize: 50,
        companyName: '',
        companyCode: '',
        bankName: '',
        bankCode: '',
        securityUser: '',
        legalPerson: ''
      },
      tableList: [],
      total: 0,
      sumData: {},
      companyList: [],
      bankNameList: [],
      securityTypeList: [],
      legalPersonList: [],
      securityUserList: [],
      termYearsList: [],
      imgList: [],
      creditFileList: [],
      creditFileFlag: false,
      lookImgFlag: false,
      imgUrl: '',
      detailLoanAmountDisplay: '',
      detailUnUseCreditAmountDisplay: '',
      dialogVisible: false,
      dialogTitle: '新增银行授信',
      isDetail: false,
      isEdit: false,
      addForm: { },
      rules: {
        companyName: [{ required: true, message: '请选择/输入公司', trigger: 'change' }],
        bankName: [{ required: true, message: '请选择/输入银行', trigger: 'change' }],
        creditAmount: [
          { required: true, message: '请输入授信金额', trigger: 'change' },
          { validator: (rule, value, cb) => { if (Number(value) > 0) cb(); else cb(new Error('授信金额必须大于0')); }, trigger: 'change' }
        ],
        creditExpireDate: [{ required: true, message: '请选择授信到期日', trigger: 'change' }],
        securityTypeCode: [{ required: true, message: '请选择担保方式', trigger: 'change' }],
        securityUserARR: [{ required: true, message: '请选择/输入担保人', trigger: 'change' }],
        isCredit: [{ required: true, message: '请选择是否上征信', trigger: 'change' }],
        legalPerson: [{ required: true, message: '请选择/输入法人', trigger: 'change' }],
        creditLife: [{ required: true, message: '请选择/输入授信年限', trigger: 'change' }],
        hockLife: [{ required: true, message: '请选择/输入抵押年限', trigger: 'change' }],
        creditMode: [{ required: true, message: '请选择授信方式', trigger: 'change' }]
      },
      h: '',
      btnFlg: [],
      btnIdArr: ['00FM180100', '00FM180200', '00FM180300', '00FM180400', '00FM180500', '00FM180600', '00FM180700', '00FM180800']
    }
  },
  computed: {
    unusedAmount () {
      const credit = parseFloat(this.addForm.creditAmount) || 0
      const loaned = parseFloat(this.addForm.loanAmount) || 0
      return (credit - loaned).toFixed(2)
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/bankCredit')
    this.getDictList()
    this.getList()
  },
  mounted () {
    var h = (this.$refs.searchBox && this.$refs.searchBox.offsetHeight) || 80
    var pH = (document && document.documentElement && document.documentElement.clientHeight) || 800
    this.h = Math.max(pH - h - 165, 200) + 'px'
  },
  methods: {
    // 预警标记：授信到期日 / 未用金额 命中「预警」时单元格背景标淡红（参考 vgs-driver2.0 司机页 getCellStyle）
    cellStyle ({ row, column }) {
      if (column.property === 'creditExpireDate' && row.creditDateReminder === '预警') {
        return { background: '#FEB0A4' }
      }
      if (column.property === 'unUseCreditAmount' && row.creditLimitReminder === '预警') {
        return { background: '#FEB0A4' }
      }
      return {}
    },
    getDictList () {
      var map = [
        ['bankNameList', 'bank_name'],
        ['securityTypeList', 'security_type'],
        ['legalPersonList', 'legal_person'],
        ['securityUserList', 'security_user'],
        ['termYearsList', 'term_years']
      ]
      map.forEach(arr => {
        var key = arr[0]; var groupNo = arr[1]
        // 项目标准字典下拉接口，直接返回数组 [{itemNo, showName}]
        getDictionaryDetailList({ dictionaryType: groupNo }).then(res => {
          this[key] = Array.isArray(res) ? res : []
        }).catch(e => { this[key] = []; this._showError(e, '加载字典失败：' + groupNo) })
      })
      // 公司下拉改用 companySetting/getUserCompanyDropDown，返回 { data: [{companyCode, companyName}] }
      getUserCompanyDropDown().then(res => {
        this.companyList = res || []
      }).catch(e => { this.companyList = []; this._showError(e, '加载公司下拉失败') })
    },
    getList () {
      var loading = this.$loading({ lock: true, text: '加载中...' })
      findCreditInfoList(this.searchForm).then(res => {
        loading.close()
        var d = res || {}
        this.tableList = d.list.list || []
        this.total = d.list.total
        this.sumData = { totalAmount: d.creditAmountAll, totalLoaned: d.loanAmountAll, totalUnused: d.unUsecreditAmountAll }
      }).catch(err => {
        loading.close()
        this.tableList = []
        this.total = 0
        this.sumData = { totalAmount: '0.00', totalLoaned: '0.00', totalUnused: '0.00' }
        this._showError(err, '获取银行授信列表失败')
      })
    },
    searchFn () {
      this.searchForm.pageNo = 1
      this.getList()
    },
    resetForm () {
      // 搜索字段与 data.searchForm 声明一致：直接赋值空骨架 + 回到第 1 页
      this.searchForm = { pageNo: 1, pageSize: 50, companyName: '', companyCode: '', bankName: '', bankCode: '', securityUser: '', legalPerson: '' }
      this.getList()
    },
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.getList()
    },
    companyNameChange (val) {
      var hit = (this.companyList || []).find(i => (i.companyName || i.showName) === val)
      this.addForm.companyCode = hit ? (hit.companyCode || hit.itemNo || hit.id || '') : ''
    },
    bankNameChange (val) {
      var hit = (this.bankNameList || []).find(i => i.showName === val)
      this.addForm.bankCode = hit ? (hit.itemNo || hit.id || '') : ''
    },
    securityTypeChange (val) {
      var hit = (this.securityTypeList || []).find(i => i.itemNo === val)
      this.addForm.securityTypeName = hit ? hit.showName : ''
    },

    // 新增/修改/详情弹窗：清空表单 + 附件 + 详情金额只读展示
    resetAddDialog () {
      this.addForm = { deleteFileIds: [] }
      this.imgList = []
      this.detailLoanAmountDisplay = ''
      this.detailUnUseCreditAmountDisplay = ''
    },
    addFn () {
      this.isEdit = false
      this.isDetail = false
      this.dialogTitle = '新增银行授信'
      this.resetAddDialog()
      this.dialogVisible = true
      this.$nextTick(() => { this.$refs.addForm && this.$refs.addForm.clearValidate() })
    },
    // 详情/修改：统一调 credit/getCreditInfo 回填
    _fetchDetailAndShow (row, mode) {
      this.isEdit = mode === 'edit'
      this.isDetail = mode === 'detail'
      this.dialogTitle = mode === 'edit' ? '修改银行授信' : '银行授信详情'
      this.dialogVisible = true
      var loading = this.$loading({ lock: true, text: '加载中...' })
      getCreditInfo({ id: row.id }).then(res => {
        loading.close()
        this.addForm = res.finCreditInfo
        this.addForm.deleteFileIds = []
        // 担保人：后端存逗号分隔字符串，回显拆成数组赋给页面字段 securityUserARR
        this.$set(this.addForm, 'securityUserARR', this.addForm.securityUser ? String(this.addForm.securityUser).split(',') : [])
        this.imgList = (res.files || []).map((f) => ({
          status: 'ready', url: f.fileKeyUrl, id: f.id, name: f.filePath.split('/').pop()
        }))
        this.$nextTick(() => { this.$refs.addForm && this.$refs.addForm.clearValidate() })
      }).catch(err => {
        loading.close()
        this._showError(err, '获取银行授信详情失败')
      })
    },
    editFn   (row) { this._fetchDetailAndShow(row, 'edit') },
    detailFn (row) { this._fetchDetailAndShow(row, 'detail') },

    saveFn () {
      var vm = this
      if (!vm.$refs.addForm) return
      vm.$refs.addForm.validate(function (valid) {
        if (!valid) { vm.$message.warning('请检查表单必填项'); return }
        var f = Object.assign({}, vm.addForm || {})

        // 担保人多选（页面字段 securityUserARR）→ 逗号分隔字符串 securityUser 传给后端，并剔除 ARR 字段
        if (Array.isArray(f.securityUserARR)) f.securityUser = f.securityUserARR.join(',')
        delete f.securityUserARR

        // Integer 空值 → null，避免后端类型转换报错
        if (f.isCredit === '' || f.isCredit == null) f.isCredit = null
        // 删除的附件 id 放进 params（remove 方法维护），和 vhcInsurance 保持一致
        if (!Array.isArray(f.deleteFileIds)) f.deleteFileIds = []

        var isUpdate = !!(f.id && vm.isEdit)
        var files = (vm.imgList || []).filter(function (x) { return x && x.raw })
        var apiFn = isUpdate ? updateCreditInfo : addCreditInfo
        var loading = vm.$loading({ lock: true, text: '保存中...' })

        // 始终用 FormData：params=JSON，files=新附件（参考 vhcInsurance 的 saveOrUpdateWithAttachments）
        var fd = new FormData()
        fd.set('params', JSON.stringify(f))
        files.forEach(function (x) { fd.append('files', x.raw, x.name || (x.raw && x.raw.name) || 'file') })

        var done = function () {
          loading.close()
          vm.$message.success(isUpdate ? '修改成功' : '新增成功')
          vm.close()
          vm.getList()
        }
        var fail = function (err) {
          loading.close()
          vm._showError(err, isUpdate ? '修改银行授信失败' : '新增银行授信失败')
        }
        apiFn(fd).then(done).catch(fail)
      })
    },
    delFn (row) {
      var _this = this
      _this.$confirm('是否删除此银行授信记录？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        var loading = _this.$loading({ lock: true, text: '删除中...' })
        deleteCreditInfo({ id: row.id })
          .then(function () {
            loading.close()
            _this.$message.success('删除成功')
            _this.getList()
          })
          .catch(function (err) {
            loading.close()
            _this._showError(err, '删除银行授信失败')
          })
      }).catch(function () {})
    },
    exportFn () {
      var _this = this
      var prefix = (_this.global && _this.global.smpName) ? _this.global.smpName : ''
      var url = prefix + '/credit/exportCreditInfo'
      var params = Object.assign({}, _this.searchForm)
      delete params.pageNo
      delete params.pageSize
      var loading = _this.$loading({ lock: true, text: '导出中...' })
      exportExcel(url, params, '银行授信')
        .then(function () { loading.close() })
        .catch(function (err) {
          loading.close()
          _this._showError(err, '导出银行授信失败')
        })
    },
    creditFileFn (row) {
      var vm = this
      var loading = this.$loading({ lock: true, text: '加载中...' })
      getCreditInfo({ id: row.id }).then(function (res) {
        loading.close()
        var files = (res.files || []).map(function (f) {
          return {
            name: f.filePath ? f.filePath.split('/').pop() : (f.name || '未命名文件'),
            url: f.fileKeyUrl
          }
        })
        if (files.length === 0) {
          vm.$alert('暂无可查看的授信资料', '系统提示')
        } else {
          vm.creditFileList = files
          vm.creditFileFlag = true
        }
      }).catch(function (err) {
        loading.close()
        vm._showError(err, '获取授信资料失败')
      })
    },
    creditFileClick (item) {
      if (this.isImage(item.name)) {
        this.imgUrl = item.url
        this.lookImgFlag = true
      } else {
        window.open(item.url)
      }
    },
    isImage (filename) {
      var ext = (filename.split('.').pop() || '').toLowerCase()
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].indexOf(ext) > -1
    },
    loanDetailFn (row) {
      this.$router.push({
        path: '/loanManage',
        query: { creditId: row.id }
      })
    },
    // 删除附件时记录 id（已有附件才有 id），保存时随 params.deleteFileIds 一起提交
    remove (file) {
      if (file && file.id != null && file.id !== '') {
        if (!this.addForm.deleteFileIds) this.addForm.deleteFileIds = []
        if (this.addForm.deleteFileIds.indexOf(file.id) === -1) this.addForm.deleteFileIds.push(file.id)
      }
    },
    // 统一错误提示：原 _showError 未定义会让 catch 二次抛错，吞掉后端真实报错
    _showError (err, msg) {
      var m = msg
      if (err) {
        if (err.msg) m = err.msg
        else if (err.message) m = err.message
        else if (err.response && err.response.data && err.response.data.msg) m = err.response.data.msg
      }
      this.$message.error(m)
    },
    close () {
      this.dialogVisible = false
      this.resetAddDialog()
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
.sumBox {
  padding: 10px 0;
  font-size: 14px;
  color: #333;
  span {
    color: #F56C6C;
    font-weight: bold;
    font-size: 14px;
  }
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333 !important;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #333 !important;
  -webkit-text-fill-color: #333 !important;
}
.fujianBox {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  /deep/.el-button--text {
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
</style>
